export default __webpack_public_path__ + "static/logo-white-658c340f8e7d7817ce59b91f464cb684.svg";